import axios from 'axios';
import qs from 'qs';
const Axios = axios.create({
  baseURL: process.env.VUE_APP_APIPATH, // 后台服务地址
  timeout: 60000 // 请求超时时间1分钟
  // responseType: "json",
});

const codeMessage = {
  400: '客户端请求错误',
  401: '未认证',
  403: '禁止访问，请登录',
  404: '请求失败，未找到',
  405: '请求方法不允许',
  415: '请求的媒体类型有误',
  500: '服务器发生错误',
  502: '网关错误',
  503: '服务器暂时过载或维护',
  504: '网关超时'
};

const request = ({
  url,
  method = 'POST',
  data,
  contentType = 'application/json',
  headers = {},
  ...otherConfig
} = {}) => {
  headers = {
    ...headers,
    'Content-Type': contentType
  };
  if (contentType === 'application/x-www-form-urlencoded') {
    data = qs.stringify(data);
  }

  return new Promise((resolve, reject) => {
    Axios({
      url,
      method: method,
      data: data,
      crossOrigin: true,
      withCredentials: true,
      headers,
      ...otherConfig
    })
      .then(response => {
        const responseData = response.data;
        if (responseData.code === 200) {
          resolve(responseData);
        } else {
          reject(response);
        }
      })
      .catch(e => {
        console.log('请求异常:', e);
        const response = e.response || {};
        const errortext = codeMessage[response.status] || e.message || e.msg || response.statusText || '请求错误';
        e.errortext = errortext;
        reject(e);
      });
  });
};

export default request;
